import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import { MobilePopMenu } from './Common';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold'
    },
  },
};
const childTabs = [
  {
    name: "Access From",
    id: "Ratings",
    defaultChecked: true,
  },
  {
    name: "Access Information",
    id: "Enquiries",
  },
];
//$.DataTable = require('datatables.net')

const columns_af = [
  {
    name: 'City',
    selector: row => row.location,
    sortable: true,
  },
  {
    name: 'No of Persons',
    selector: row => row.count,
  },
  {
    name: 'Month',
    selector: row => row.date,
  },
];
const columns_ai = [
  {
    name: 'Type',
    selector: row => row.name,
    sortable: true,
  },
  {
    name: 'Counts',
    selector: row => row.count,
  },
];


class partnerReports extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: ''
    }

    this.getpageData();
  }
  componentDidMount() {
  }

  showMTab = (element) => {
        
        $('.submenu-list a').each(function(){
                 $(this).removeClass('active');
         
        });

        $("."+element).addClass("active");
        $(".mainblock").removeClass('active').addClass('hidden');
        $("#"+element).removeClass('hidden').addClass('active');
               
        //document.getElementById(element).style.display = 'block';
  }
  
  getpageData = async () => {
    const { user_type, login_id, set_id } = this.state.auth_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getAbout'
    });
    await partnerApi(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({
          category_data: response.result.master_data,
        });
        const data = response.result.master_data;
        if (data.length > 0) {
          data.map(async (item, index) => {
            let userinfo = JSON.stringify({
              user_id: login_id,
              category: item.cid,
              main_id: item.mid,
            });
            getContactServiceList(userinfo).then((response) => {
              if (response.status == 1) {
                item.partner_connect = response.result;
              }
            });
            getDeviceAccess(userinfo).then((response) => {
              if (response.status == 1) {
                item.access_from = response.result;
              }
            });
            getWishList(userinfo).then((response) => {
              if (response.status == 1) {
                item.access_info = response.result;
              }
            });
          })
        }
        let THIS = this;
        this.setState({
          checking: true
        })
        setTimeout(function () {
          THIS.setState({
            checking: false
          })
        }, 5000)
      }
    });
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render() {
    const { category_data, collapse } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Reports</h4>
                   
                  {category_data.length>0 && (
                  <Tabs tabsetName="Comments" tabClassName="custom-tab" childTabs={childTabs}>
                        
                        <TabsPane id="Ratings">
                          {category_data.map((item, index) => {
                            return (
                              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                                <CardHeader onClick={() => this.toggle(index)} data-event={index} className='custom-card-heading'>
                                  <b>{item.category_name}</b>
                                  <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                                  {collapse !== index ? (
                                    <span className='pull-right'>
                                      <i class="fa fa-plus" aria-hidden="true"></i>
                                    </span>
                                  ) : (
                                    <span className='pull-right'>
                                      <i class="fa fa-minus" aria-hidden="true"></i>
                                    </span>
                                  )}
                                </CardHeader>
                                <Collapse isOpen={collapse === index}>
                                  <CardBody className='panel-body'>
                                    {item.is_active == 0 ?
                                      (
                                        <div className='row mar-btm'>
                                          <div class="form-group col-md-12">
                                            <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                                          </div>
                                        </div>
                                      ) :
                                      (
                                        <div>
                                          {item.access_from && item.access_from.length > 0 && (
                                            <button className='btn btn-sm btn-success pull-right' onClick={(e) => this.exportAccessFrom(e, item)}>Export</button>
                                          )}
                                          <DataTable
                                            title=""
                                            columns={columns_af}
                                            data={item.access_from}
                                            pagination
                                            customStyles={customStyles}
                                            loading={"please wait ..it is processing"}
                                            noDataComponent=" Not enough data to provide this info" //or your component
                                            paginationComponentOptions={{ noRowsPerPage: true }}
                                          />
                                        </div>
                                      )
                                    }
                                  </CardBody>
                                </Collapse>
                              </Card>
                            )
                          })}
                        </TabsPane>
                        <TabsPane id="Enquiries">
                          {category_data.map((item, index) => {
                            return (
                              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                                <CardHeader onClick={() => this.toggle(index)} data-event={index} className='custom-card-heading'>
                                  <b>{item.category_name}</b>
                                  <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                                  {collapse !== index ? (
                                    <span className='pull-right'>
                                      <i class="fa fa-plus" aria-hidden="true"></i>
                                    </span>
                                  ) : (
                                    <span className='pull-right'>
                                      <i class="fa fa-minus" aria-hidden="true"></i>
                                    </span>
                                  )}
                                </CardHeader>
                                <Collapse isOpen={collapse === index}>
                                  <CardBody className='panel-body'>
                                    {item.is_active == 0 ?
                                      (
                                        <div className='row mar-btm'>
                                          <div class="form-group col-md-12">
                                            <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                                          </div>
                                        </div>
                                      ) :
                                      (
                                        <div>
                                          {item.access_info && item.access_info.length > 0 && (
                                            <button className='btn btn-sm btn-success pull-right' onClick={(e) => this.exportAccessInfo(e, item)}>Export</button>
                                          )}
                                          <DataTable
                                            title=""
                                            columns={columns_ai}
                                            data={item.access_info}
                                            
                                            loading={"please wait ..it is processing"}
                                            customStyles={customStyles}
                                            //paginationComponentOptions={{ noRowsPerPage: true }}
                                          />
                                        </div>
                                      )
                                    }
                                  </CardBody>
                                </Collapse>
                              </Card>
                            )
                          })}
                        </TabsPane>
                      </Tabs>
                  )}
                  {category_data.length==0 && 
                  <div>Please wait...loading...</div>
                  }
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }


  sendReply = (row) => {
    this.setState({
      modalReply: true,
      current_comment: row.comments,
      current_eid: row.email,
      current_rid: row.id,
    })
  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }
  replyMail = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      msg: this.state.new_reply,
      rid: this.state.current_rid,
      toemail: this.state.current_eid,
      login_id: this.state.auth_data.login_id,
      set_id: this.state.auth_data.set_id,
      url: 'reply_service'
    });
    vendorDashboard(req).then(response => {
      if (response.status === 1) {
        this.getpageData();
        this.setState({
          modalReply: false,
          current_comment: '',
          current_eid: '',
          current_rid: 0,
        })
      }
    })
  }
  cancelPop = (e) => {
    e.preventDefault();
    this.setState({
      modalReply: false,
      current_comment: '',
      current_eid: '',
      current_rid: 0,
    })
  }
  exportConnect = (e, item) => {
    e.preventDefault();
    let req = JSON.stringify({
      category: item.cid,
      main_id: item.mid,
      login_id: this.state.auth_data.login_id,
      url: 'connectExport'
    });
    vendorDashboard(req).then(response => {
      if (response.status === 1) {
        window.open(response.path);
      }
    })
  }
  exportAccessFrom = (e, item) => {
    e.preventDefault();
    let req = JSON.stringify({
      category: item.cid,
      main_id: item.mid,
      login_id: this.state.auth_data.login_id,
      url: 'accessFromExport'
    });
    vendorDashboard(req).then(response => {
      if (response.status === 1) {
        window.open(response.path);
      }
    })
  }
  exportAccessInfo = (e, item) => {
    e.preventDefault();
    let req = JSON.stringify({
      category: item.cid,
      main_id: item.mid,
      login_id: this.state.auth_data.login_id,
      url: 'accessInfoExport'
    });
    vendorDashboard(req).then(response => {
      if (response.status === 1) {
        window.open(response.path);
      }
    })
  }
}

export default partnerReports;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/reports.jsx